import { resolveShellSplashVariant, type ShellSplashVariant } from './shellSplashTheme'

const STORAGE_KEY = 'sigchatExpmgrDevShellSplashVariant'

function isVariant(v: string | null): v is ShellSplashVariant {
  return v === 'blue' || v === 'light'
}

export function readDevShellSplashVariantFromSession(): ShellSplashVariant | null {
  if (!import.meta.env.DEV) return null
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (raw !== null && isVariant(raw)) return raw
  } catch {
    return null
  }
  return null
}

export function writeDevShellSplashVariantToSession(variant: ShellSplashVariant): void {
  if (!import.meta.env.DEV) return
  try {
    sessionStorage.setItem(STORAGE_KEY, variant)
  } catch {
    return
  }
}

export function initialDevShellSplashVariant(): ShellSplashVariant {
  const stored = readDevShellSplashVariantFromSession()
  if (stored !== null) return stored
  return resolveShellSplashVariant(import.meta.env.VITE_SHELL_SPLASH_VARIANT)
}
